const config = {
  connectGWEndpoint: 'http://localhost:9191/',
  login: 'http://localhost:9191/saml2/authenticate/feedback-admin',
  allRoles: ['ROLE_CARFEEDBACK_ADMINS', 'ROLE_CARFEEDBACK_USERS', 'ROLE_CARFEEDBACK_READER'],
  adminRole: 'ROLE_CARFEEDBACK_ADMINS',
  userRole: 'ROLE_CARFEEDBACK_USERS',
  readerRole: 'ROLE_CARFEEDBACK_READER'
}

export default config;
